import React from 'react';
import { CapturesCarousel } from './CapturesCarousel';
import { VideoTestimonial } from './VideoTestimonial';
interface TestimonialsProps {
  onOpenPopup: () => void;
}
export function Testimonials({
  onOpenPopup
}: TestimonialsProps) {
  // Capturas de pantalla de resultados reales de alumnos
  const captures = ['https://cdn.magicpatterns.com/uploads/jfjy8tsctU6wA4bRRMYuVc/1.webp', 'https://cdn.magicpatterns.com/uploads/qFi92fzrQdLUzaSHt87qPX/2.webp', 'https://cdn.magicpatterns.com/uploads/7zqJ93szEY7eZAhwU71NfG/3.webp', 'https://cdn.magicpatterns.com/uploads/tXtwUdvTFt1NLaK33qSwZ2/4.webp', 'https://cdn.magicpatterns.com/uploads/pUJ3xv3yKagVam7bjxXo1r/5.webp'];
  // Videos de testimonios. Agregá el youtubeId para mostrar el video real;
  // dejá undefined para mantener el placeholder editable.
  const videoTestimonials: {
    youtubeId?: string;
  }[] = [{
    youtubeId: 'sFJ0HuCkSvk'
  }, {
    youtubeId: 'AyyW53kWOfE'
  }, {
    youtubeId: '3OnhrmsQZ1s'
  }, {
    youtubeId: 'gsyoFerdsDQ'
  }];
  return <section className="py-20 bg-black" data-id="element-104">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-105">
        <div className="text-center max-w-4xl mx-auto mb-16" data-id="element-106">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 uppercase tracking-wide" data-id="element-107">
            CASOS DE ÉXITO
          </h2>
          <p className="text-gray-300 text-lg" data-id="element-108">
            Alumnos que ya venden sus Ebooks. Mirá más en mi{' '}
            <a href="https://instagram.com/tomasbenaviidez" target="_blank" rel="noopener noreferrer" className="underline hover:text-brand-orange transition-colors" data-id="element-109">
              instagram
            </a>{' '}
            <strong className="text-white" data-id="element-110">@tomasbenaviidez</strong>, generando
            entre $2.000 y $10.000 USD al mes
          </p>
        </div>

        {/* Capturas de pantalla de resultados (carrusel) */}
        <div className="mb-16" data-id="element-111">
          <CapturesCarousel images={captures} data-id="element-112" />
        </div>

        {/* Grid de Videos de Testimonios */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto mb-16" data-id="element-113">
          {videoTestimonials.map((video, i) => <VideoTestimonial key={i} index={i} youtubeId={video.youtubeId} data-id="element-114" />)}
        </div>

        <div className="flex justify-center" data-id="element-115">
          <button onClick={onOpenPopup} className="px-8 py-4 bg-brand-orange hover:bg-red-600 text-white text-lg font-bold rounded-lg transition-all transform hover:scale-105 active:scale-95 box-glow" data-id="element-116">
            ACCEDER AL CURSO GRATIS
          </button>
        </div>
      </div>
    </section>;
}